<template>
  <div
    v-if="career"
    class="careers"
  >
    <!-- Content -->
    <div class="careers__content">
      <!-- Title -->
      <title-view variant="primary align-left">
        {{ career.name }}
      </title-view>

      <div
        v-for="(section, index) in career.text"
        :key="index"
      >
        <text-view variant="small-margin subtitle align-left">
          <h3>{{ section.title }}</h3><br>
        </text-view>
        <text-view>
          <div v-html="section.body" />
          <br>
        </text-view>
      </div>
    </div>

    <!-- Action -->
    <a
      :href="career.url"
      target="_blank"
      rel="noopener noreferrer"
      class="careers__action"
    >

      <button-view variant="title big">
        {{ career.action }}
      </button-view>

    </a>

    <!-- Footer -->
    <footer-follow-view />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import api from '@/services/careers/service';
import handleErrors from '@/utils/handler-errors';
import * as messages from '@/utils/error-messages';

export default {
  name: 'CareersShow',

  components: {
    ButtonView: () => import('@/components/button/button-view'),
    TextView: () => import('@/components/text/text-view'),
    TitleView: () => import('@/components/title/title-view'),
    FooterFollowView: () => import('@/components/footer/footer-follow-view')
  },

  metaInfo() {
    return {
      title: `Careers: ${this.career.name}`,
      meta: [
        {
          name: 'description',
          content: 'Join an award-winning team!'
        },
        {
          property: 'og:url',
          content: (this.career === undefined) ? 'https://www.blissapplications.com/careers' : `https://www.blissapplications.com/careers/${this.career.id}`
        },
        {
          property: 'og:title',
          content: (this.career === undefined) ? 'Join an award-winning team!' : `We are hiring! ${this.career.name}`
        },
        {
          property: 'og:description',
          content: 'Join an award-winning team!'
        },
        {
          property: 'og:image',
          content: 'https://www.blissapplications.com/static/images/bliss-share-facebook-careers.png'
        },
        {
          name: 'twitter:title',
          content: (this.career === undefined) ? 'Join an award-winning team!' : `We are hiring! ${this.career.name}`
        },
        {
          name: 'twitter:description',
          content: 'Join an award-winning team!'
        },
        {
          name: 'twitter:image',
          content: 'https://www.blissapplications.com/static/images/bliss -share-facebook-careers.png'
        }
      ]
    };
  },

  computed: {
    ...mapState('careers', {
      careers: (state) => state.careers,
      career: (state) => state.career
    })
  },
  async serverPrefetch() {
    const { id } = this.$route.params;
    await api.getCareerById(id).then((response) => {
      this.$store.dispatch('careers/getCareerById', response);
    }).catch(() => {
      handleErrors(messages.MESSAGE_2, 'careers_index');
    });
  },

  async mounted() {
    const { id } = this.$route.params;

    await api.getCareerById(id).then((response) => {
      this.$store.dispatch('careers/getCareerById', response);
    }).catch(() => {
      handleErrors(messages.MESSAGE_2, 'careers_index');
    });
  },

  methods: {
    ...mapActions('careers', [
      'getCareerById'
    ])
  }
};
</script>

<style lang="scss" src="@/assets/pages/careers.scss"></style>



// WEBPACK FOOTER //
// show.vue